import fetch from 'isomorphic-fetch'

export interface Endpoint {
  url: string
  method: 'GET' | 'POST'
  parameters?: Record<string, string>
  headers?: Record<string, string>
  credentials?: RequestCredentials
}

export const dataFetcher = async <T>({ url, method, parameters, headers, credentials }: Endpoint): Promise<T> => {
  const urlWithParams = new URL(url)
  if (parameters) {
    Object.entries(parameters).forEach(([paramName, value]) => {
      urlWithParams.searchParams.set(paramName, value)
    })
  }

  const response = await fetch(urlWithParams, {
    method,
    headers,
    credentials,
  })

  //TODO include logging
  if (!response.ok) throw new Error(response.statusText)

  const data = await response.json()

  return data
}
